var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGridHeadCell } from './data-grid-head-cell';
import { useLang } from '../hooks/use-lang';
var cls = classNames('data-grid-head');
export var DataGridHeadDefaultProps = {
  showGutter: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GutterCellStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    z-index: 10;\n    border-right: 1px solid ", ";\n    position: sticky;\n    left: 0;\n  "], ["\n    z-index: 10;\n    border-right: 1px solid ", ";\n    position: sticky;\n    left: 0;\n  "])), theme.COLOR('line-subtle'))
});
// -------- Components -------->
var My = {
  NAME: 'DataGridHead',
  Container: styled.tr(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  GutterCell: styled(DataGridHeadCell)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), GutterCellStyles)
};
export var DataGridHead = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridHeadDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    showGutter = componentProps.showGutter;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showGutter && React.createElement(My.GutterCell, {
    id: "actions"
  }, ' '), children);
};
DataGridHead.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;